/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Components.Controls {

    interface IAttrs extends angular.IAttributes {
        targetId: string
    }

    /**
     * Directive requires attribute 'target-id' to be able to copy target's content
     * */
    export class MeevoCopy implements angular.IDirective {
        restrict = 'A';
        template = '';

        link = (scope: any, element: JQuery, attrs: IAttrs) => {

            element.bind('click', () => {
                let target = angular.element(`#${attrs.targetId}`);
                var body = angular.element(document.body);
                var textarea = angular.element('<textarea/>');
                textarea.css({
                    position: 'fixed',
                    opacity: '0'
                });
                                
                if (target && target.val()) {
                    textarea.val(target.val());
                    body.append(textarea);

                    if (navigator.userAgent.match(/ipad|iphone/i)) {
                        var range, selection;
                        var elements = document.getElementsByTagName('textarea');
                        var el = _.last(elements);
                        range = document.createRange();
                        range.selectNodeContents(el);
                        selection = window.getSelection();
                        selection.removeAllRanges();
                        selection.addRange(range);
                        el.focus();
                        el.setSelectionRange(0, 999999);
                    } else {
                        textarea.select();
                    }

                    try {
                        document.execCommand('copy');
                        target.blur();
                    }
                    catch (err) {
                        this.modalService.alert('Please press "Ctrl/Cmd + C" to copy.');
                    }

                    textarea.remove();
                } else {
                    console.log("Didn't find target or it does not have 'select' method");
                }
            });
        };

        constructor (protected modalService: Meevo.Components.Modal.IModalService) {}

        static factory(): angular.IDirectiveFactory {
            let directive = (
                modalService: Meevo.Components.Modal.IModalService
            ) => {
                return new MeevoCopy(modalService);
            };

            directive.$inject = ['meevo.components.modal.ModalService'];

            return directive;
        }
    }

    angular.module('meevo.components.controls')
        .directive('meevoCopy', MeevoCopy.factory());
}